/**
 * Notes on Collage Site Mocks
 * https://tps-wiki.topcon.com/display/PC/Notes+on+Collage+Site+Mocks
 */

import { logService } from './externalCommunicationMocks/core/Log';
import { PointCloudVizExternalMocks } from './externalCommunicationMocks/PointCloudVizExternalMocks';

function enableMocks(urlOrCommand: string): boolean {
    // 'window.mocksEnabled' is a global var used in some parts of mocked events as a string variable
    // if you want to disable this global variable after set, call window.enableMocks('mocksDisabled')
    if (urlOrCommand) {
        if (urlOrCommand.includes('mocksenabled') || urlOrCommand === 'mocksdisabled') {
            const previous = (window as any).mocksEnabled;

            (window as any).mocksEnabled = urlOrCommand;
            if (previous) {
                return true;
            }

            if (urlOrCommand === 'mocksdisabled') {
                (window as any).mocksEnabled = '';
                // TODO. disable mocks and restore communications
                return false;
            }
        } else {
            logService.warn('urlOrCommand for mocksEnabled is not valid: ', urlOrCommand);
            return false;
        }
    }

    /* External Communications mocks */
    new PointCloudVizExternalMocks().run();

    logService.info('MOCKS: ENABLED!!');
    return true;
}

function checkMocksEnableUrl(): void {
    const url = window.location.href.toLowerCase();
    if (url.includes('mocksenabled')) {
        (window as any).enableMocks(url);
    }
}

export function initializeMocks(): void {
    (window as any).enableMocks = enableMocks;

    checkMocksEnableUrl();
}
